export default __webpack_public_path__ + "static/media/logo_image.d419d013.svg";